import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ListIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 25)}
      {...svgProps}
      viewBox="0 0 512 512"
      fill={color}
    >
      <path d="m64 128.042c-36.267 0-64-27.733-64-64s27.733-64 64-64 64 27.733 64 64-27.733 64-64 64zm0-96c-17.067 0-32 14.934-32 32s14.934 32 32 32 32-14.933 32-32-14.933-32-32-32zm0 288.001c-36.267 0-64-27.733-64-64s27.733-64 64-64 64 27.733 64 64-27.733 64-64 64zm0-96.001c-17.067 0-32 14.934-32 32s14.934 32 32 32 32-14.933 32-32-14.933-32-32-32zm0 288.001c-36.267 0-64-27.733-64-64s27.733-64 64-64 64 27.733 64 64-27.733 64-64 64zm0-96c-17.067 0-32 14.933-32 32s14.934 32 32 32 32-14.933 32-32-14.933-32-32-32zm430.933-341.333h-320c-8.534 0-17.066-6.4-17.066-17.067s8.534-14.934 17.066-14.934h320c10.666 0 17.067 6.4 17.067 14.934s-6.4 17.067-17.067 17.067zm0 191.999h-320c-8.534 0-17.066-6.4-17.066-17.066s8.534-14.934 17.066-14.934h320c8.534 0 17.067 6.4 17.067 17.066s-6.4 14.934-17.067 14.934zm0 192h-320c-8.534 0-17.066-6.4-17.066-17.067s8.534-14.933 17.066-14.933h320c8.534 0 17.067 6.4 17.067 17.067s-6.4 14.933-17.067 14.933z" />
    </SVG>
  );
};
